import { Component, HostListener } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { AttachmentComponent } from "../attachment/attachment.component";
import { AddFollowupComponent } from "../add-followup/add-followup.component";
import { AddTicketComponent } from "../add-ticket/add-ticket.component";
import { AddSubscriptionComponent } from "../add-subscription/add-subscription.component";
import { ViewHistoryComponent } from "../view-history/view-history.component";
import { AddCommentComponent } from "../add-comment/add-comment.component";
import { AddSalesAlertComponent } from "../add-sales-alert/add-sales-alert.component";
import { AddTrainerTicketComponent } from "../add-trainer-ticket/add-trainer-ticket.component";
import { BlockClientComponent } from "../block-client/block-client.component";
import { EditCustomerComponent } from "../edit-customer/edit-customer.component";
import { CashbackComponent } from "../cashback/cashback.component";
import { InvitationComponent } from "../invitation/invitation.component";
import { PaymentsComponent } from "../payments/payments.component";
import { FreezeHistoryComponent } from "../freeze-history/freeze-history.component";
import { BenefitUsageHistoryComponent } from "../benefit-usage-history/benefit-usage-history.component";
import { ChangesLogComponent } from "../changes-log/changes-log.component";
import { AttendanceHistoryComponent } from "../attendance-history/attendance-history.component";
import { Invitation2Component } from "../invitation2/invitation2.component";
import { RequestServiceComponent } from "../request-service/request-service.component";
import Swal from "sweetalert2";
import { EditSalesRepresentativeComponent } from "../edit-sales-representative/edit-sales-representative.component";
import { EditCoachComponent } from "../edit-coach/edit-coach.component";
import { InvoiceComponent } from "../invoice/invoice.component";
import { Router } from "@angular/router";
import { EditPlanStartDateComponent } from "../edit-plan-start-date/edit-plan-start-date.component";
import { InnerTransferComponent } from "../inner-transfer/inner-transfer.component";
import { OuterTransferComponent } from "../outer-transfer/outer-transfer.component";
import { UpgradeComponent } from "../upgrade/upgrade.component";
import { DowngradeComponent } from "../downgrade/downgrade.component";
import { RefundComponent } from "../refund/refund.component";
import { EditSubscriptionBenefitsComponent } from "../edit-subscription-benefits/edit-subscription-benefits.component";
import { CancelSubscriptionComponent } from "../cancel-subscription/cancel-subscription.component";
import { SendMessageComponent } from "../send-message/send-message.component";
interface Subscription {
  name: string;
  stage: string;
  subscriptionDate: string;
  endDate: string;
  subscriptionCount: number;
  endedCount: number;
  actualCount: number;
  numberOfSessions: number;
  totalSessions: number;
  procedureType: string;
  email: string;
}
const exampleCustomer = {
  firstName: "عميل إختبار",
  middleName: "",
  lastName: "",
  phone: "0111111119",
  landline: "",
  email: "",
  address: "",
  addressExtra: "",
  city: "Cairo",
  birthDate: "2026-02-02",
  nationalId: "",
  membershipNumber: 1,
  accessCode: "1",
  location: "TestBranch",
  bank: "Egypt",
  salesManager: "testusernewui",
  trainer: "None",
  company: "None",
  gender: "ذكر",
  emergencyName: "",
  emergencyPhone: "",
};
@Component({
  selector: "fury-profile",
  templateUrl: "./profile.component.html",
  styleUrls: ["./profile.component.scss"],
})
export class ProfileComponent {
  constructor(
    private dialog: MatDialog,
    private router: Router,
  ) {}

  customerName = "محمد كامل عامل";
  customerInfo = {
    mobileNumber: "01111088880",
    landlineNumber: "N06/7348",
    apartmentNumber: "20",
    streetName: "شارع التعديلات الخاصة",
    city: "مدينة السعيد",
    email: "kareem.hany.elrouda-31",
    registrationNumber: "1300",
    registrationDate: "يسعى التحقق على أمل",
  };

  subscriptions: Subscription[] = [
    {
      name: "ANNUAL * GOLD Christmas Deal",
      stage: "فعال",
      subscriptionDate: "2025-12-22",
      endDate: "2026-12-22",
      subscriptionCount: 6,
      actualCount: 7,
      endedCount: 30,
      numberOfSessions: 3200,
      totalSessions: 0,
      procedureType: "kareem.hany.elrouda-31",
      email: "kareem.hany.elrouda-31",
    },
    {
      name: "vip (Annual)",
      stage: "تحويل نشاطى",
      subscriptionDate: "2025-05-27",
      endDate: "2026-05-27",
      subscriptionCount: 10,
      actualCount: 20,
      endedCount: 60,
      numberOfSessions: 4200,
      totalSessions: 0,
      procedureType: "kareem.hany.elrouda-31",
      email: "kareem.hany.elrouda-31",
    },
  ];

  // Menu options for the three-dot menu
  menuOptions = ["تعديل", "حذف", "إضافة ملاحظة", "طباعة", "تصدير"];

  // Selected menu index
  selectedMenuIndex: number | null = null;

  // Toggle menu visibility
  toggleMenu(index: number, event: MouseEvent) {
    event.stopPropagation();

    if (this.selectedMenuIndex === index) {
      this.selectedMenuIndex = null;
      return;
    }
    this.selectedMenuIndex = index;

    setTimeout(() => {
      const menus = document.querySelectorAll(".menu-container .dropdown-menu");
      const menu = menus[menus.length - 1] as HTMLElement;
      if (menu) {
        const btn = event.currentTarget as HTMLElement;
        const rect = btn.getBoundingClientRect();
        const menuWidth = menu.offsetWidth || 200;

        // تحت الزرار
        menu.style.top = `${rect.bottom + window.scrollY + 4}px`;

        // محاذاة يمين المينو مع يمين الزرار
        let left = rect.right - menuWidth;
        if (left < 8) left = 8;

        menu.style.left = `${left}px`;
      }
    }, 0);
  }

  useCashBack() {
    this.dialog.open(CashbackComponent, {
      maxHeight: "90vh",
      panelClass: "top-dialog-panel",
      position: { top: "20px" },
    });
  }
  usedInvitations() {
    this.dialog.open(InvitationComponent, {
      maxHeight: "90vh",
      panelClass: "top-dialog-panel",
      position: { top: "20px" },
    });
  }
  payments() {
    this.dialog.open(PaymentsComponent, {
      maxHeight: "90vh",
      panelClass: "top-dialog-panel",
      position: { top: "20px" },
    });
  }
  freezeHistory() {
    this.dialog.open(FreezeHistoryComponent, {
      maxHeight: "90vh",
      panelClass: "top-dialog-panel",
      position: { top: "20px" },
    });
  }
  benefitUsage() {
    this.dialog.open(BenefitUsageHistoryComponent, {
      maxHeight: "90vh",
      panelClass: "top-dialog-panel",
      position: { top: "20px" },
    });
  }
  changesLog() {
    this.dialog.open(ChangesLogComponent, {
      maxHeight: "90vh",
      panelClass: "top-dialog-panel",
      position: { top: "20px" },
    });
  }
  attendanceHistory() {
    this.dialog.open(AttendanceHistoryComponent, {
      maxHeight: "90vh",
      panelClass: "top-dialog-panel",
      position: { top: "20px" },
    });
  }
  invitation() {
    this.dialog.open(Invitation2Component, {
      maxHeight: "90vh",
      panelClass: "top-dialog-panel",
      position: { top: "20px" },
    });
  }
  requestService() {
    this.dialog.open(RequestServiceComponent, {
      maxHeight: "90vh",
      panelClass: "top-dialog-panel",
      position: { top: "20px" },
    });
  }
  suspendSubscription() {
    Swal.fire({
      toast: true,
      position: "top-end",
      icon: "success",
      title: "تم الحفظ بنجاح",
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      background: "#fff",
    });
  }
  editSales() {
    this.dialog.open(EditSalesRepresentativeComponent, {
      maxHeight: "90vh",
      panelClass: "top-dialog-panel",
      position: { top: "20px" },
    });
  }
  editCoach() {
    this.dialog.open(EditCoachComponent, {
      maxHeight: "90vh",
      panelClass: "top-dialog-panel",
      position: { top: "20px" },
    });
  }
  invoice(): void {
    const invoiceData = {
      membershipCode: "1",
      accessCode: "1",
      customerName: "عميل إختبار",
      phone: "0111111119",
      plan: "خطة تجريبية",
      salesEmployee: "testusernewui",
      trainer: "",
      paymentDate: "12-02-2026 17:08:56",
      startDate: "Feb 12, 2026",
      endDate: "Feb 15, 2026",
      totalRequired: 1000,
      paidCash: 500,
      paidCard: 200,
      paidTransfer: 200,
      totalPaid: 900,
      remaining: 100,
      discount: 0,
      notes: "",
      benefits: [
        { name: "Freeze", count: 1 },
        { name: "Massage", count: 1 },
        { name: "Inbody", count: 1 },
        { name: "Meditation", count: 1 },
        { name: "Cupping", count: 1 },
        { name: "Invitations", count: 1 },
        { name: "PTSessions", count: 1 },
        { name: "Fitness", count: 1 },
        { name: "Nutrations", count: 1 },
        { name: "FreeDays", count: 1 },
      ],
    };

    const printContents = `
    <div style="width:595px; min-height:842px; font-family:Arial, sans-serif; margin:auto;">
      <h2 style="text-align:center;">TestBranch</h2>
      <h3 style="text-align:center;">إيصال إستلام نقدية</h3>
      <p style="text-align:center;">اشتراك</p>
      <div style="margin-top:20px;">
        <p>كود العضوية: ${invoiceData.membershipCode}</p>
        <p>كود الدخول: ${invoiceData.accessCode}</p>
        <p>اسم المشترك: ${invoiceData.customerName}</p>
        <p>تليفون المشترك: ${invoiceData.phone}</p>
        <p>العضوية: ${invoiceData.plan}</p>
        <p>موظف المبيعات: ${invoiceData.salesEmployee}</p>
        <p>المبلغ المطلوب: ${invoiceData.totalRequired}</p>
        <p>المدفوع نقداً: ${invoiceData.paidCash}</p>
        <p>المدفوع بطاقة: ${invoiceData.paidCard}</p>
        <p>المدفوع تحويل: ${invoiceData.paidTransfer}</p>
        <p>إجمالي المدفوع: ${invoiceData.totalPaid}</p>
        <p>المتبقي: ${invoiceData.remaining}</p>
        <p>الخصم: ${invoiceData.discount}%</p>
      </div>
      <div style="margin-top:10px;">
        <p>المزايا:</p>
        ${invoiceData.benefits.map((b) => `<p>${b.name} ${b.count}</p>`).join("")}
      </div>
    </div>
  `;

    // عرض النافذة في نص الشاشة
    const width = 650; // عرض النافذة
    const height = 900; // ارتفاع النافذة
    const left = window.innerWidth / 2 - width / 2;
    const top = window.innerHeight / 2 - height / 2;

    const popupWin = window.open(
      "",
      `width=${width},height=${height},top=${top},left=${left},scrollbars=yes,resizable=yes`,
    );

    if (!popupWin) return;

    popupWin.document.open();
    popupWin.document.write(`
    <html>
      <head>
        <title>Invoice</title>
        <style>
          body { font-family: Arial, sans-serif; font-size: 0.82rem; margin:0; }
        </style>
      </head>
      <body onload="window.print(); window.close();">
        ${printContents}
      </body>
    </html>
  `);
    popupWin.document.close();
  }
  editPlanStart() {
    this.dialog.open(EditPlanStartDateComponent, {
      maxHeight: "90vh",
      panelClass: "top-dialog-panel",
      position: { top: "20px" },
    });
  }
  innerTransfer() {
    this.dialog.open(InnerTransferComponent, {
      maxHeight: "90vh",
      panelClass: "top-dialog-panel",
      position: { top: "20px" },
    });
  }
  outerTransfer() {
    this.dialog.open(OuterTransferComponent, {
      maxHeight: "90vh",
      panelClass: "top-dialog-panel",
      position: { top: "20px" },
    });
  }
  upgrade() {
    this.dialog.open(UpgradeComponent, {
      maxHeight: "90vh",
      panelClass: "top-dialog-panel",
      position: { top: "20px" },
    });
  }
  downgrade() {
    this.dialog.open(DowngradeComponent, {
      maxHeight: "90vh",
      panelClass: "top-dialog-panel",
      position: { top: "20px" },
    });
  }
  refund() {
    this.dialog.open(RefundComponent, {
      maxHeight: "90vh",
      panelClass: "top-dialog-panel",
      position: { top: "20px" },
    });
  }
  editBenefits() {
    this.dialog.open(EditSubscriptionBenefitsComponent, {
      maxHeight: "90vh",
      panelClass: "top-dialog-panel",
      position: { top: "20px" },
    });
  }
  editBenefitsInvoice() {
    this.dialog.open(EditSubscriptionBenefitsComponent, {
      maxHeight: "90vh",
      panelClass: "top-dialog-panel",
      position: { top: "20px" },
    });
  }
  cancelSubscription() {
    this.dialog.open(CancelSubscriptionComponent, {
      maxHeight: "90vh",
      panelClass: "top-dialog-panel",
      position: { top: "20px" },
    });
  }

  OpenAttachmentComponent() {
    this.dialog.open(AttachmentComponent, {
      width: "620px",
      position: { top: "20px" },
    });
  }
  OpenAddFollowupComponent() {
    this.dialog.open(AddFollowupComponent, {
      maxHeight: "90vh",
      panelClass: "top-dialog-panel",
      position: { top: "20px" },
    });
  }
  AddTicketComponent() {
    this.dialog.open(AddTicketComponent, {
      maxHeight: "90vh",
      panelClass: "top-dialog-panel",
      position: { top: "20px" },
    });
  }
  sendMessage() {
    this.dialog.open(SendMessageComponent, {
      maxHeight: "90vh",
      // no position needed — centers by default
    });
  }
  OpenAddSubscriptionComponent() {
    this.dialog.open(AddSubscriptionComponent, {
      width: "40%",
      maxHeight: "90vh",
      panelClass: "top-dialog-panel",
      position: { top: "20px" },
    });
  }
  openHistoryDialog() {
    const historyData = [
      {
        date: "2026-02-11",
        userName: "testusernewui",
        time: "23:16:01",
      },
      {
        date: "2026-02-11",
        userName: "testusernewui",
        time: "20:45:22",
      },
    ];

    this.dialog.open(ViewHistoryComponent, {
      width: "620px",
      position: { top: "20px" },
      hasBackdrop: true,

      data: historyData,
    });
  }
  addSalesTicket() {
    this.dialog.open(AddSalesAlertComponent, {
      width: "560px",
      maxWidth: "95vw",
      panelClass: "top-dialog-panel",
      position: { top: "20px" },
      disableClose: false,
      autoFocus: false,
    });
  }
  addTrainerTicket() {
    this.dialog.open(AddTrainerTicketComponent, {
      width: "560px",
      maxWidth: "95vw",
      panelClass: "top-dialog-panel",
      position: { top: "20px" },
      disableClose: false,
      autoFocus: false,
    });
  }
  showDropdown = false;
  toggleDropdown() {
    this.showDropdown = !this.showDropdown;
  }
  closeDropdown() {
    this.showDropdown = false;
  } // وظائف القائمة المنسدلة
  // addApplication() {    console.log('إضافة تطبيق');    this.closeDropdown();    // إضافة المنطق هنا  }  addSalesTicket() {    console.log('إضافة تذكرة لمسؤول المبيعات');    this.closeDropdown();    // إضافة المنطق هنا  }  addTrainerTicket() {    console.log('إضافة تذكرة للمدرب');    this.closeDropdown();    // إضافة المنطق هنا  }  editRecord() {    console.log('تعديل');    this.closeDropdown();    // إضافة المنطق هنا  }  viewRecord() {    console.log('عرض');    this.closeDropdown();    // إضافة المنطق هنا  }  blockClient() {    console.log('حظر العميل');    this.closeDropdown();    // إضافة المنطق هنا  }
  // Close menu when clicking outside
  closeMenu(): void {
    this.selectedMenuIndex = null;
  }
  addApplication() {
    this.dialog.open(AddCommentComponent, {
      width: "620px",
      position: { top: "20px" },
      panelClass: "top-dialog-panel",
    });
  }
  blockClient() {
    this.dialog.open(BlockClientComponent, {
      width: "560px",
      maxWidth: "95vw",
      panelClass: "top-dialog-panel",
      position: { top: "20px" },
      disableClose: false,
      autoFocus: false,
    });
  }
  viewRecord() {
    this.dialog.open(EditCustomerComponent, {
      width: "70%",
      maxWidth: "95vw",
      maxHeight: "95vh",
      panelClass: "top-dialog-panel",
      position: { top: "20px" },
      disableClose: false,
      autoFocus: false,
      data: {
        customer: exampleCustomer, // بيانات العميل
        editMode: false, // ← وضع العرض
      },
    });
  }
  editRecord() {
    this.dialog.open(EditCustomerComponent, {
      width: "70%",

      maxWidth: "95vw",
      maxHeight: "95vh",
      panelClass: "top-dialog-panel",
      position: { top: "20px" },
      disableClose: false,
      autoFocus: false,
      data: {
        customer: exampleCustomer, // بيانات العميل
        editMode: true, // ← وضع التعديل
      },
    });
  }
  interactions = [
    {
      username: "managment2o",
      status: "Line Busy",
      date: "February 12, 2026",
      time: "7:30 am",
      note: "testtest",
    },
    {
      username: "managment2o",
      status: "Line Busy",
      date: "February 12, 2026",
      time: "7:30 am",
      note: "testtest",
    },
    // Add more entries here as needed
  ];
  DeleteAttachment() {}
  attachments = [
    {
      action: "...",
      createdBy: "managmenth2o",
      comment: "تجربة",
      attachmenturl:
        "https://cms.h2ogym.net/clientuploads/CEOC9BD4_F76A_411B_B5FC_4C239ABF3A3.jpg",
      attachmentstatus: 1,
      fileName: "CEOC9BD4_F76A_411B_B5FC_4C239ABF3A3",
      createdAt: "18:08:01 - 02-09-2026",
    },
    {
      action: "...",
      createdBy: "managmenth2o",
      comment: " 2 تجربة",
      attachmenturl:
        "https://cms.h2ogym.net/clientuploads/CEOC9BD4_F76A_411B_B5FC_4C239ABF3A3.jpg",
      attachmentstatus: 0,
      fileName: "CEOC9BD4_F76A_411B_B5FC_4C239ABF3A3",
      createdAt: "18:08:01 - 02-09-2024",
    },
    // Add more rows as needed
  ];
  calls = [
    {
      type: "عرض",
      createdBy: "استفسار عام",
      creator: "أحمد محمد",
      callType: "صادرة",
      callDate: "2024-05-20",
    },
    // Add more rows as needed
  ];
  activeTabIndex = 1;
  // Handle menu option click
  onMenuOptionClick(option: string, subscription: Subscription): void {
    console.log(
      "Selected option:",
      option,
      "for subscription:",
      subscription.name,
    );
    this.selectedMenuIndex = null;
  }
  selectedCommentMenuIndex: number | null = null;

  toggleCommentMenu(index: number, event: MouseEvent): void {
    event.stopPropagation();
    this.selectedCommentMenuIndex =
      this.selectedCommentMenuIndex === index ? null : index;
  }

  // Close both menus on outside click
  @HostListener("document:click")
  onDocumentClick(): void {
    this.selectedMenuIndex = null;
    this.selectedCommentMenuIndex = null;
  }

  DeleteComment(item: any): void {
    // your delete logic here
  }

  EditComment(item: any): void {
    // your edit logic here
  }
  selectedCallMenuIndex: number | null = null;

  toggleCallMenu(index: number, event: MouseEvent): void {
    event.stopPropagation();
    this.selectedCallMenuIndex =
      this.selectedCallMenuIndex === index ? null : index;
  }
  DeleteCall(call: any): void {
    // your delete logic here
  }
}
